const MODE_ACTIVE = ["bg-sunburst", "text-obsidian"];
const MODE_IDLE = ["text-obsidian/70", "hover:text-obsidian"];
const TAB_ACTIVE = ["bg-obsidian", "text-sunburst"];
const TAB_IDLE = ["bg-white", "text-obsidian", "hover:bg-sunburst"];

function swapClasses(element, active, idle, isActive) {
    element.classList.remove(...(isActive ? idle : active));
    element.classList.add(...(isActive ? active : idle));
}

function init() {
    document.querySelectorAll("[data-pricing-page]").forEach((page) => {
        const modeButtons = [...page.querySelectorAll("[data-pricing-mode]")];
        const tabsWrap = page.querySelector("[data-pricing-tabs]");
        const tabs = [...page.querySelectorAll("[data-pricing-tab]")];
        const panels = [...page.querySelectorAll("[data-pricing-panel]")];
        const menuPanel = panels.find((panel) => !tabs.some((tab) => tab.dataset.pricingTab === panel.dataset.dietId));

        if (!panels.length) return;

        const showDiet = (dietId) => {
            panels.forEach((panel) => {
                panel.hidden = panel.dataset.dietId !== String(dietId);
            });

            tabs.forEach((tab) => {
                const isActive = tab.dataset.pricingTab === String(dietId);
                tab.setAttribute("aria-selected", isActive ? "true" : "false");
                swapClasses(tab, TAB_ACTIVE, TAB_IDLE, isActive);
            });
        };

        const setMode = (mode) => {
            modeButtons.forEach((button) => {
                const isActive = button.dataset.pricingMode === mode;
                button.setAttribute("aria-pressed", isActive ? "true" : "false");
                swapClasses(button, MODE_ACTIVE, MODE_IDLE, isActive);
            });

            if (tabsWrap) tabsWrap.hidden = mode === "menu";

            if (mode === "menu" && menuPanel) {
                showDiet(menuPanel.dataset.dietId);
                return;
            }

            const selectedTab = tabs.find((tab) => tab.getAttribute("aria-selected") === "true") || tabs[0];
            if (selectedTab) showDiet(selectedTab.dataset.pricingTab);
        };

        modeButtons.forEach((button) => {
            button.addEventListener("click", () => setMode(button.dataset.pricingMode));
        });

        tabs.forEach((tab) => {
            tab.addEventListener("click", () => showDiet(tab.dataset.pricingTab));
        });
    });
}

export default {init};
